import React from 'react';
import { StarIcon, CheckCircleIcon } from 'lucide-react';
interface Review {
  name: string;
  rating: number;
  text: string;
  timeframe: string;
  imageUrl: string;
}
const reviews: Review[] = [{
  name: 'Michael R.',
  rating: 5,
  text: 'After five months, my crown is noticeably thicker. My barber even commented on it. No side effects, just results.',
  timeframe: '6 months of use',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/iuJP7EMwLjjA3HNeNTJ6sT/Images-2.png'
}, {
  name: 'David K.',
  rating: 5,
  text: 'I was skeptical about red light therapy, but this actually works. My hairline has filled in and I feel confident again.',
  timeframe: '4 months of use',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/uYS339bTt1gsrDoxYxGNnK/Images-9.png'
}, {
  name: 'James T.',
  rating: 5,
  text: "Best investment I've made. 10 minutes a day while I check emails. No drugs, no surgery, just science.",
  timeframe: '7 months of use',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/eU6ccvi8MBwTuajLVADnxy/Images-13.png'
}];
export function SocialProof() {
  return <section className="w-full bg-white py-20 px-4" data-id="element-246">
      <div className="max-w-7xl mx-auto" data-id="element-247">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-248">
          <h2 className="text-4xl md:text-5xl font-extrabold text-brand-black mb-4" data-id="element-249">
            Trusted by 75,000+ Men
          </h2>
          <p className="text-xl text-gray-700" data-id="element-250">
            Real results from real customers
          </p>
        </div>

        {/* Review Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-251">
          {reviews.map((review, index) => <div key={index} className="bg-white rounded-xl shadow-lg p-8 border border-gray-200" data-id="element-252">
              {/* Star Rating */}
              <div className="flex items-center gap-1 mb-4" data-id="element-253">
                {[...Array(review.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" aria-hidden="true" data-id="element-254" />)}
              </div>

              {/* Review Text */}
              <p className="text-gray-700 leading-relaxed mb-6" data-id="element-255">
                "{review.text}"
              </p>

              {/* Before/After Image */}
              <div className="rounded-lg overflow-hidden mb-4" data-id="element-256">
                <img src={review.imageUrl} alt={`Before and after hair regrowth comparison for ${review.name}`} className="w-full h-full object-cover" data-id="element-257" />
              </div>

              {/* Customer Info */}
              <div className="flex items-center justify-between" data-id="element-258">
                <div data-id="element-259">
                  <p className="font-bold text-brand-black" data-id="element-260">{review.name}</p>
                  <p className="text-sm text-gray-600" data-id="element-261">{review.timeframe}</p>
                </div>
                <CheckCircleIcon className="w-6 h-6 text-green-500" aria-label="Verified customer" data-id="element-262" />
              </div>
            </div>)}
        </div>

        {/* Trust Indicators */}
        <div className="flex flex-wrap items-center justify-center gap-8 text-center" data-id="element-263">
          <div data-id="element-264">
            <p className="text-4xl font-extrabold text-brand-black" data-id="element-265">75,000+</p>
            <p className="text-gray-600" data-id="element-266">Happy Customers</p>
          </div>
          <div className="hidden md:block w-px h-12 bg-gray-300" data-id="element-267"></div>
          <div data-id="element-268">
            <p className="text-4xl font-extrabold text-brand-black" data-id="element-269">4.8/5</p>
            <p className="text-gray-600" data-id="element-270">Average Rating</p>
          </div>
          <div className="hidden md:block w-px h-12 bg-gray-300" data-id="element-271"></div>
          <div data-id="element-272">
            <p className="text-4xl font-extrabold text-brand-black" data-id="element-273">94%</p>
            <p className="text-gray-600" data-id="element-274">Would Recommend</p>
          </div>
        </div>
      </div>
    </section>;
}